// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getIsMobileSalesAccount } from "@store/Framework/Store/Data/Accounts/AccountsSelectors";

export const useIsMobileSalesAccount = () => {
    return useAppSelector(state => getIsMobileSalesAccount(state));
};
